import { PIXI } from '@colonist/pixi';
import { Viewport } from 'pixi-viewport';
import { SectionBgView } from '../../ui_canvas_engine/SectionBgView.ts';
import { UIGameMapViewLayers } from './UIGameMapViewLayers.ts';
export class UIGameMapView extends Viewport {
    initMapSizes() {
        this.hexagonHeight = this.height / 5.3 // because it looks good
        ;
        this.hexagonWidth = this.hexagonHeight / 2 * Math.sqrt(3);
        this.robberRadius = this.hexagonHeight / 2.7;
        this.pirateRadius = this.hexagonHeight / 3;
        this.merchantRadius = this.hexagonHeight / 4.7;
        this.cornerCircleR = this.hexagonHeight / 5.2 // it is 5.2 because it looks good
        ;
    }
    repositionMap(location) {
        this.left = location.x;
        this.top = location.y;
    }
    disableInteraction() {
        this.plugins.pause('drag');
        this.plugins.pause('pinch');
        this.plugins.pause('wheel');
        this.plugins.pause('decelerate');
        this.plugins.pause('clamp');
        this.plugins.pause('clampZoom');
        this.interactiveChildren = false;
    }
    enableInteraction() {
        this.plugins.resume('drag');
        this.plugins.resume('pinch');
        this.plugins.resume('wheel');
        this.plugins.resume('decelerate');
        this.plugins.resume('clamp');
        this.plugins.resume('clampZoom');
        this.interactiveChildren = true;
    }
    getTileLeftCenterCircle(hexFace) {
        const tileCenter = hexFace.toPixel(this.mapCenter, this.hexagonHeight / 2);
        return new PIXI.Circle(tileCenter.x, tileCenter.y - this.hexagonHeight / 6, this.hexagonHeight / 6);
    }
    constructor(x, y, w, h, app){
        super({
            screenWidth: w,
            screenHeight: h,
            events: app.renderer.events
        }), this.DEFAULT_ZOOM_EVENT = {
            type: 'animate',
            viewport: this
        };
        const bg = new SectionBgView(x, y, w, h, this);
        app.stage.addChild(this);
        // activate plugins
        this.drag().pinch().wheel();
        this.initMapSizes();
        this.originalWidth = w;
        this.originalHeight = h;
        this.layers = new UIGameMapViewLayers();
    }
}
